/* Wasteland NYC: burger menu + touch dropdowns */
document.addEventListener('click', function (e) {
  var b = e.target.closest('.wl-burger');
  if (b) {
    var open = document.body.classList.toggle('wl-menu-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    return;
  }
  var nvLink = e.target.closest('.wl-nav .wl-nv > a');
  if (nvLink && window.matchMedia('(hover: none)').matches) {
    var nv = nvLink.parentNode;
    if (!nv.classList.contains('wl-open')) {
      e.preventDefault();
      document.querySelectorAll('.wl-nav .wl-nv.wl-open').forEach(function (n) { n.classList.remove('wl-open'); });
      nv.classList.add('wl-open');
    }
    return;
  }
  if (!e.target.closest('.wl-nav')) {
    document.querySelectorAll('.wl-nav .wl-nv.wl-open').forEach(function (n) { n.classList.remove('wl-open'); });
  }
});
